module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/IQ-693b57960b26e8cb911e3d6247c50e2d.png";